import type { EnrichedReadyToSharePlatformPostV2 } from 'src/app/shared/api/readyToShare';

export function getPostTypeForTracking(post: EnrichedReadyToSharePlatformPostV2): string {
	if (post.postTypeName === 'group') {
		return `${post.platform}_group`;
	}
	return `${post.platform}_${post.postTypeName}`;
}
